import { useEffect, useState } from "react";
import { useFetcher, useLocation, useParams } from "react-router-dom";
import { editUserEvents, getUserEvent } from "../../services/UserServices/UserService";
import { Card, Button, Modal, Form, Row, Col } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { User } from "lucide-react";
import PageTitle from "../layouts/PageTitle";
import toast from "react-hot-toast";
import { EVENT_NAME } from "../../utils/events";
import Pagination from "../components/Pagination";
import PageContentLoader from "../components/TableLoader";


const UserEvents = () => {
  const { id } = useParams();
  const [userEvent, setUserEvent] = useState({});
  const navigate = useNavigate()
  const [totalItems, setTotalItems] = useState(0);
  const [sortBy, setSortBy] = useState("")
  const location = useLocation();
  const historyData = location.state?.history;
  const [loader, setLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [events, setEvents] = useState({})
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
 const [filterDate,setFilterDate]=useState("")
 const [endDate,setEndDate]=useState("")


//   const getEvent = async () => {
//     setLoader(true)
//     try {
//       const res = await getUserEvent(id, currentPage, 10,filterDate,endDate, sortBy);
//       console.log("respinse", res?.data?.data?.events)
//       setTotalItems(res?.data?.data?.count || 0);
//       const data = res?.data?.data?.events

//       const sortedEvents = res?.data?.data?.events



// const mappedEvents = sortedEvents
//   .map((response) => {
//     const eventId = response?.name?.id;

//     // 🔑 MATCH BY ID (NOT NAME)
//     const matchEvent = EVENT_NAME.find(
//       (event) => event.id === eventId
//     );

//     // If custom event or no match
//     if (!matchEvent) {
//       return {
//         id: eventId || "custom",
//         name: response?.name?.name || "Custom Event",
//         eventId: response._id,
//         eventVenue: response.eventVenue,
//         eventDate: response.eventDate,
//         subEvents: response.subEvents || [],
//         selectedTheme: response.theme,
//         selectedDressCode: response.dressCode,
//         selectedDressColor: response.dressColor,
//         isGalleryExists: response.isGalleryExists,
//         theme: [],
//         dressCode: [],
//         dressColor: [],
//       };
//     }

//     // helper to resolve dropdown/custom values
//     const resolveValue = (staticList, responseItem) => {
//       if (!responseItem) return null;

//       if (responseItem.id === "custom") {
//         return responseItem;
//       }

//       return staticList.find(
//         (item) => item.id === responseItem.id
//       ) || responseItem;
//     };

//     return {
//       ...matchEvent,
//       eventId: response._id,
//       eventVenue: response.eventVenue,
//       eventDate: response.eventDate,
//       subEvents: response.subEvents || [],
//       selectedTheme: resolveValue(matchEvent.theme, response.theme),
//       selectedDressCode: resolveValue(matchEvent.dressCode, response.dressCode),
//       selectedDressColor: resolveValue(matchEvent.dressColor, response.dressColor),
//       isGalleryExists: response.isGalleryExists,
//     };
//   })
//   .filter(Boolean);
//   setUserEvent(mappedEvents)

//     } catch (error) {
//       console.error(error?.response?.data?.message);
//     }
//     finally {
//       setLoader(false)
//     }
//   };
  
const getEvent = async () => {
  setLoader(true);
  try {
    const res = await getUserEvent(id, currentPage, 10, filterDate, endDate, sortBy);
    console.log("response", res?.data?.data?.events);
    setTotalItems(res?.data?.data?.count || 0);

    const sortedEvents = res?.data?.data?.events || []; // Added fallback to empty array

    const mappedEvents = sortedEvents
      .map((response) => {
        const eventId = response?.name?.id;

        // 🔑 MATCH BY ID (NOT NAME)
        const matchEvent = EVENT_NAME.find((event) => event.id === eventId);

        // If custom event or no match
        if (!matchEvent) {
          return {
            id: eventId || "custom",
            name: response?.name?.name || "Custom Event",
            eventId: response._id,
            eventVenue: response.eventVenue,
            eventDate: response.eventDate,
            subEvents: response.subEvents || [],
            selectedTheme: response.theme,
            selectedDressCode: response.dressCode,
            selectedDressColor: response.dressColor,
            isGalleryExists: response.isGalleryExists,
            theme: [],
            dressCode: [],
            dressColor: [],
          };
        }

        // helper to resolve dropdown/custom values
        const resolveValue = (staticList, responseItem) => {
          if (!responseItem) return null;

          // ✅ Explicitly return the custom text typed by the user
          if (responseItem.id === "custom") {
            return {
              id: "custom",
              name: responseItem.name || "Custom",
            };
          }

          return (
            staticList.find((item) => item.id === responseItem.id) ||
            responseItem
          );
        };

        return {
          ...matchEvent,
          // ✅ OVERRIDE the static name with the actual typed name from the response
          name: response?.name?.name || matchEvent.name,
          
          eventId: response._id,
          eventVenue: response.eventVenue,
          eventDate: response.eventDate,
          subEvents: response.subEvents || [],
          selectedTheme: resolveValue(matchEvent.theme, response.theme),
          selectedDressCode: resolveValue(matchEvent.dressCode, response.dressCode),
          selectedDressColor: resolveValue(matchEvent.dressColor, response.dressColor),
          isGalleryExists: response.isGalleryExists,
        };
      })
      .filter(Boolean);

    setUserEvent(mappedEvents);
  } catch (error) {
    console.error(error?.response?.data?.message);
  } finally {
    setLoader(false);
  }
};
useEffect(() => {

    if (id) {
      getEvent();
    }
  }, [sortBy, currentPage,filterDate,endDate]);


  useEffect(() => {

    setCurrentPage(0)
  }, [sortBy,filterDate,endDate]);




  

  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const handleEdit = (event) => {


    setEvents(event)
    setShowModal(true)

  }


 const user = historyData?.user
   



  if (loader) {
    return (
      <div className="qx-page">
        <PageContentLoader message="Loading events..." />
      </div>
    );
  }

  return (
    <div className="qx-page">
  <PageTitle
  breadcrumbs={[
    {
      label: "User List",
      path: "/user-management",
    },
    {
      label: historyData?.user?.hostName || "User",
      path: `/user-details/${historyData?.user?._id}`,
    },
    {
      label: "Events",
    },
  ]}
/>



   <div className="pb-3 d-flex  justify-content-between gap-3">

  {/* Start Date */}
 <div className=" d-flex  justify-content-between gap-3">
   <Form.Group>
    <Form.Label className="fw-semibold" style={{ color: "#3F3F46" }}>
      Start Date
    </Form.Label>
    <Form.Control
      type="date"
      value={filterDate}
      onChange={(e) => setFilterDate(e.target.value)}
      style={{ borderRadius: "8px", minWidth: "180px" }}
    />
  </Form.Group>

  {/* End Date */}
  <Form.Group>
    <Form.Label className="fw-semibold" style={{ color: "#3F3F46" }}>
      End Date
    </Form.Label>
    <Form.Control
      type="date"
      value={endDate}
      onChange={(e) => setEndDate(e.target.value)}
      style={{ borderRadius: "8px", minWidth: "180px" }}
    />
  </Form.Group>
 </div>

  {/* Event Type */}
  <Form.Group>
    <Form.Label className="fw-semibold" style={{ color: "#3F3F46" }}>
      Event Type
    </Form.Label>
    <Form.Select
      value={sortBy}
      onChange={(e) => setSortBy(e.target.value)}
      style={{ borderRadius: "0.5rem", minWidth: "200px" }}
    >
      <option value="">All Types</option>
      <option value="custom">Custom</option>
      <option value="0">Roka</option>
      <option value="2">Haldi</option>
      <option value="1">Engagement</option>
      <option value="5">Cocktail</option>
      <option value="6">Wedding</option>
      <option value="4">Sangeet</option>
      <option value="7">Music Bash</option>
      <option value="8">Reception</option>
      <option value="3">Mehndi</option>
    </Form.Select>
  </Form.Group>

</div>



      {userEvent && userEvent?.length > 0 ? userEvent.map((event, index) => (

        <Card key={index} className="shadow-lg event-card mb-5 roun" >
          <Card.Body >


            <div

              className="event-item mb-4 p-3 rounded   justify-content-between align-items-center"
            >
              {/* Left side - Event details */}
            <div className="mb-4">
  <h5 className="fw-bold mb-3">{event?.name}</h5>

  <div className="row">
    <div className="col">
      <strong className="label-text">Date</strong>
      <div>
        {new Date(event?.eventDate).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "long",
          year: "numeric",
        })}
      </div>
    </div>

    <div className="col">
      <strong className="label-text">Venue</strong>
      <div>{event?.eventVenue || "N/A"}</div>
    </div>

    <div className="col">
      <strong className="label-text">Theme</strong>
      <div>{event?.selectedTheme?.name || "N/A"}</div>
    </div>

    <div className="col">
      <strong className="label-text">Dress Code</strong>
      <div>{event?.selectedDressCode?.name || "N/A"}</div>
    </div>

    <div className="col">
      <strong className="label-text">Dress Color</strong>
      <div>{event?.selectedDressColor?.name || "N/A"}</div>
    </div>
  </div>
</div>


              {/* Right side - Buttons */}
              <div className="d-flex  ">


{event?.isGalleryExists ?  ( <Button
                  className="me-2 maroon-btn"
                  onClick={() => navigate(`/user-photo-gallery/${event?.eventId}`,{
                      state: { history: { user, event} }
                    })}
                >
                  Photos
                </Button>):""}

               



                <Button
                  className="me-2 maroon-btn"
                  onClick={() => navigate(`/guests/${id}/${event?.eventId}`, {
                    state: { history: { user,event } }
                  })}
                >
                  Guests
                </Button>

                {event?.subEvents && event?.subEvents.length > 0 && (<>
                  <Button
                    className="me-2 maroon-btn"
                    onClick={() => navigate(`/sub-events/${id}/${event?.eventId}`, {
                      state: { history: { event } }
                    })}
                  >
                    Sub Events
                  </Button></>)}
                <Button
                  className="me-2 maroon-btn"
                  onClick={() => navigate(`/tasks/${id}/${event?.eventId}`, {
                    state: { history: {user, event } }
                  })}
                >
                  Tasks
                </Button>
                <Button
                  className="me-2 maroon-btn"
                  onClick={() => {
                    handleEdit(event)
                  }}
                >
                  Edit
                </Button>
              </div>

            </div>




          </Card.Body>

        </Card>
      )) :  <p>No data found</p>  }
     <Modal size="xl" show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Event</Modal.Title>
        </Modal.Header>

        <Formik
          initialValues={{
            
            eventId: events?.eventId,
            name: {
              name: events?.name || "",
              id: events?.id
            },
            theme: {
              name: events?.selectedTheme?.name || "",
              id: events?.selectedTheme?.id
            },
            dressCode: {
              name: events?.selectedDressCode?.name || "",
              id: events?.selectedDressCode?.id
            },
            dressColor: {
              name: events?.selectedDressColor?.name || "",
              id: events?.selectedDressColor?.id
            },
            eventVenue:events?.eventVenue,
              eventDate: events?.eventDate
      ? new Date(events.eventDate).toISOString().split("T")[0]
      : ""
            
          }}

          onSubmit={async (values) => {
            try {

              console.log("valus", { values })
              await editUserEvents(values)
              getEvent()
              toast.success("event updated successfully")


              setShowModal(false);
            } catch (error) {
              console.error(error)
            }
          }}
          enableReinitialize
        >
          {({
            handleSubmit,
            handleChange,
            values,
            errors,
            touched,
            setFieldValue
          }) => (

            <Form onSubmit={handleSubmit} className="p-3">

              {/* EVENT NAME */}
              <Form.Group className="mb-3">
                <Form.Label>Event Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  disabled
                  value={values?.name?.name}
                  onChange={handleChange}
                  isInvalid={touched?.name && errors?.name?.name}
                />
                <Form.Control.Feedback type="invalid">
                  {errors?.name?.name}
                </Form.Control.Feedback>
              </Form.Group>



              {/* Theme */}
              <Form.Group className="mb-3">
                <Form.Label>Theme</Form.Label>
                <Form.Select
                  name="theme"
                  value={values?.theme?.id || ""}
                  onChange={(e) => {
                    const selectedTheme = events?.theme?.find(
                      (item) => item.id === e.target.value
                    );
                    setFieldValue("theme", selectedTheme);
                  }}
                  isInvalid={touched?.theme && errors?.theme}
                >
                  <option value="">Select Theme</option>
                  {events?.theme?.map((theme) => (
                    <option key={theme.id} value={theme.id}>
                      {theme.name}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors?.theme?.name}
                </Form.Control.Feedback>
              </Form.Group>



              {values?.theme?.id === "custom" && (
                <Form.Group className="mt-2">
                  <Form.Label>Enter Custom Theme</Form.Label>
                  <Form.Control
                    type="text"
                    name="themeName"
                    placeholder="Enter theme name..."
                    value={values?.theme?.name || ""}
                    onChange={(e) =>
                      setFieldValue("theme", { id: "custom", name: e.target.value })
                    }
                    isInvalid={touched?.theme?.name && errors?.theme?.name}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors?.theme?.name}
                  </Form.Control.Feedback>
                </Form.Group>
              )}

     <Form.Group className="mb-3">
                <Form.Label>Dress Code</Form.Label>
                <Form.Select
                  name="dressCode"
                  value={values?.dressCode?.id || ""}
                  onChange={(e) => {
                    const selectedDress = events?.dressCode?.find(
                      (item) => item.id === e.target.value
                    );
                    setFieldValue("dressCode", selectedDress);
                  }}
                  isInvalid={touched?.dressCode && errors?.dressCode}
                >
                  <option value="">Select Dress Code</option>
                  {events?.dressCode?.map((dress) => (
                    <option key={dress.id} value={dress.id}>
                      {dress.name}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors?.dressCode?.name}
                </Form.Control.Feedback>
              </Form.Group>

     {values?.dressCode?.id === "custom" && (
                <Form.Group className="mt-2">
                  <Form.Label>Enter Custom Dress Code</Form.Label>
                  <Form.Control
                    type="text"
                    name="dressCode"
                    placeholder="Enter theme name..."
                    value={values?.dressCode?.name || ""}
                    onChange={(e) =>
                      setFieldValue("dressCode", { id: "custom", name: e.target.value })
                    }
                    isInvalid={touched?.dressCode?.name && errors?.dressCode?.name}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors?.dressCode?.name}
                  </Form.Control.Feedback>
                </Form.Group>
              )}
     <Form.Group className="mb-3">
                <Form.Label>Dress Color</Form.Label>
                <Form.Select
                  name="dressColor"
                  value={values?.dressColor?.id || ""}
                  onChange={(e) => {
                    const selectedColor = events?.dressColor?.find(
                      (item) => item.id === e.target.value
                    );
                    setFieldValue("dressColor", selectedColor);
                  }}
                  isInvalid={touched?.dressColor && errors?.dressColor}
                >
                  <option value="">Select Dress Color</option>
                  {events?.dressColor?.map((color) => (
                    <option key={color.id} value={color.id}>
                      {color.name}
                    </option>
                  ))}
                </Form.Select>


                {values?.dressColor?.id === "custom" && (
                  <Form.Group className="mt-2">
                    <Form.Label>Enter Custom Dress Color</Form.Label>
                    <Form.Control
                      type="text"
                      name="dressColor"
                      placeholder="Enter dressColor name..."
                      value={values?.dressColor?.name || ""}
                      onChange={(e) =>
                        setFieldValue("dressColor", { id: "custom", name: e.target.value })
                      }
                      isInvalid={touched?.dressColor?.name && errors?.dressColor?.name}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors?.dressColor?.name}
                    </Form.Control.Feedback>
                  </Form.Group>
                )}

 
                <Form.Control.Feedback type="invalid">
                  {errors?.dressColor?.name}
                </Form.Control.Feedback>
              </Form.Group>



  <Form.Group className="mb-3">
                <Form.Label>Event Venue</Form.Label>
                <Form.Control
                  type="text"
                  name="eventVenue"
              
                  value={values?.eventVenue || ""}
                  onChange={handleChange}
                  isInvalid={touched?.eventVenue && errors?.eventVenue}
                />
                <Form.Control.Feedback type="invalid">
                  {errors?.eventVenue}
                </Form.Control.Feedback>
              </Form.Group>

              
 <Form.Group className="mb-3">
  <Form.Label className="fw-semibold" style={{ color: "#3F3F46" }}>
    Event Date
  </Form.Label>

  <Form.Control
    type="date"
    name="eventDate"
    value={values.eventDate || ""}
    onChange={(e) => setFieldValue("eventDate", e.target.value)}
    style={{ borderRadius: "8px" }}
  />
</Form.Group>
    {/* BUTTONS */}
              <div className="d-flex justify-content-end mt-3">
                <Button variant="secondary" onClick={() => setShowModal(false)}>
                  Cancel
                </Button>
                <Button
                  type="submit"
                  className="ms-2"
                  style={{ backgroundColor: "#A60000", border: "none" }}
                >
                  Save Changes
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>




      {userEvent.length > 0 && (
        <div className="qx-pagination-only-card">
          <Pagination
            pageCount={totalPages}
            pageValue={currentPage}
            setPage={setCurrentPage}
            total={totalItems}
            pageSize={itemsPerPage}
          />
        </div>
      )}










    </div>
  )
}

export default UserEvents
